// Book-specific binding types (lowercase)
export const BOOK_BINDINGS = [
  'paperback',
  'hardcover',
  'hardback',
  'mass market paperback',
  'board book',
  'spiral-bound',
  'spiral bound',
  'ebook',
];

// Placeholder ISBNs used by seeders / backfill scripts
export const PLACEHOLDER_ISBN10 = '0000000000';
export const PLACEHOLDER_ISBN13 = '9780000000000';

/**
 * Determine whether a product object represents a book
 * (vs. a non-book product like Dry Fruits / Automobiles).
 *
 * Priority:
 *   1. `binding` — book bindings vs. "Product"
 *   2. Real (non-placeholder) ISBN / page count
 *   3. Any book-only metadata field filled in
 */
export const isProductABook = (product) => {
  if (!product) return false;

  const binding = String(product.binding || '').trim().toLowerCase();
  if (binding === 'product') return false;

  const hasSpecs = !!product.specs && Object.keys(product.specs).length > 0;
  if (hasSpecs) return false;

  const hasRealIsbn =
    (product.isbn10 && product.isbn10 !== PLACEHOLDER_ISBN10) ||
    (product.isbn13 && product.isbn13 !== PLACEHOLDER_ISBN13);

  const hasBookMeta = !!(
    product.edition ||
    product.publisher ||
    product.publisherDate ||
    product.preorderReleaseDate ||
    product.height ||
    product.width ||
    product.spineWidth ||
    product.weight
  );

  return (
    BOOK_BINDINGS.includes(binding) ||
    hasRealIsbn ||
    (typeof product.pages === 'number' && product.pages > 0) ||
    hasBookMeta
  );
};
